var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmartCashTextGradient(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9843,
    height: 1179,
    viewBox: "0 0 9843 1179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M625.659 269.559C583.22 208.661 507.247 180.359 429.379 180.359C337.238 180.359 245.792 221.737 245.792 324.773C245.792 549.985 777.479 421.491 777.479 820.997C777.479 1061.56 587.641 1179 367.804 1179C228.299 1179 92.1406 1136.11 0 1026.56L150.62 881.265C174.981 917.688 208.024 947.472 246.766 967.93C285.509 988.388 328.733 998.877 372.541 998.451C464.239 998.451 569.01 947.912 569.01 844.814C569.01 598.439 36.2499 740.073 36.2499 339.429C36.2499 107.899 242.382 0.441895 449.714 0.441895C567.116 0.441895 684.518 33.5446 771.796 116.365L625.659 269.559Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.18 28.4911H1294.33L1593.67 814.491L1896.37 28.4911H2197.61V1150.32H2007.45V218.516H2004.04L1663.84 1150.32H1523.76L1183.87 218.516H1180.14V1150.32H990.18V28.4911Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3542.08 28.4911H3931.79C4147.15 28.4911 4350.12 97.9815 4350.12 350.042C4350.12 511.639 4256.4 630.594 4089.87 654.347L4387.7 1150.32H4147.15L3887.14 674.626H3741.07V1150.32H3542.08V28.4911ZM3896.24 504.374C4009.22 504.374 4140.77 494.266 4140.77 348.336C4140.77 216.115 4016.8 199.754 3913.73 199.754H3741.07V504.374H3896.24Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4740.85 208.661H4397.61V28.4911H5284.54V208.661H4940.92V1150.32H4740.85V208.661Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6550.95 291.417C6468.28 204.428 6391.87 180.359 6314.82 180.359C6083.42 180.359 5929.58 357.939 5929.58 581.698C5929.58 820.998 6083.42 998.641 6314.82 998.641C6404.62 998.641 6492.09 957.452 6566.67 862.376L6730.87 979.689C6629.83 1119.3 6477.31 1179.32 6312.54 1179.32C5967.54 1179 5720.86 944.943 5720.86 594.396C5720.86 234.309 5967.79 0 6313.11 0C6465.25 0 6595.16 48.9592 6705.99 177.327L6550.95 291.417Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8559.98 269.559C8517.04 208.661 8440.68 180.359 8363.32 180.359C8271.18 180.359 8179.29 221.737 8179.29 324.773C8179.29 549.985 8711.8 421.491 8711.8 820.997C8711.8 1061.56 8521.65 1179 8301.3 1179C8161.92 1179 8025.32 1136.11 7933.62 1026.56L8084.88 881.265C8109.11 917.727 8142.07 947.549 8180.76 968.016C8219.46 988.483 8262.65 998.945 8306.42 998.451C8397.99 998.451 8502.57 947.912 8502.57 844.814C8502.57 598.439 7970.25 740.073 7970.25 339.429C7970.25 107.899 8176.32 0.441895 8383.53 0.441895C8501.37 0.441895 8617.83 33.5446 8705.61 116.365L8559.98 269.559Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8919.64 28.4911H9119.07V475.125H9643.25V28.4911H9842.87V589.405V1150.32H9643.31V655.926H9119.14V1150.32H8919.64V28.4911Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3102.78 300.957V504.374H3302.47V28.4911H3102.78H3059.08L2712.81 504.374H2954.18L3102.78 300.957Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2241.62 1150.38H2479.96L2828.76 674.626H2588.08L2241.62 1150.38Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3302.41 674.626H3102.78V1150.32H3302.41V674.626Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6641.32 1150.38H6879.79L7228.9 674.626H6987.84L6641.32 1150.38Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7502.67 301.209V504.374H7702.04V28.4911H7502.67H7458.9L7112.25 504.374H7353.44L7502.67 301.209Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7702.04 674.626H7502.67V1150.32H7702.04V674.626Z",
    fill: "url(#paint12_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0.00000403766,
    y1: 351,
    x2: 1194.5,
    y2: 1056.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7545FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1FDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 752,
    y1: 115.5,
    x2: 1997,
    y2: 932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7545FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1FDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 1872.5,
    y1: 28,
    x2: 3964.89,
    y2: 1150.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7545FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1FDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 3588,
    y1: 171,
    x2: 4841.07,
    y2: 1150.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7545FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1FDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 7642,
    y1: -0.000122804,
    x2: 5774,
    y2: 1125.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7545FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1FDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 8873.5,
    y1: -119.5,
    x2: 7213,
    y2: 973.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7545FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1FDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 10732.5,
    y1: -415.5,
    x2: 6990.5,
    y2: 1224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7545FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1FDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 2564.5,
    y1: 266,
    x2: 3007.64,
    y2: 504.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7545FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1FDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 2121.5,
    y1: 675,
    x2: 2535.19,
    y2: 1150.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7545FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1FDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 2121.5,
    y1: 675,
    x2: 3202.6,
    y2: 1150.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7545FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1FDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 7503.5,
    y1: 675,
    x2: 6853.5,
    y2: 1070.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7545FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1FDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 7702,
    y1: 102,
    x2: 7296,
    y2: 504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7545FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677083,
    stopColor: "#7342FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1FDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 7918.5,
    y1: 675,
    x2: 7144,
    y2: 1250,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7545FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1FDB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9843,
    height: 1179,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartCashTextGradient);
export default __webpack_public_path__ + "static/media/Smart_cash_text_Gradient.23a3f40ffa5224287edcbbbea6961329.svg";
export { ForwardRef as ReactComponent };